import React from 'react';
import { SettingsItem } from '../profileTypes';
import styles from './SettingsList.module.css';

interface SettingsListProps {
  items: SettingsItem[];
}

const icons: Record<SettingsItem['icon'], React.ReactNode> = {
  bell: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
    </svg>
  ),
  globe: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56z" />
    </svg>
  ),
  wifi: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
      <path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0z" />
    </svg>
  ),
  gear: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
      <path d="M12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
    </svg>
  ),
};

export const SettingsList: React.FC<SettingsListProps> = ({ items }) => {
  return (
    <div className={styles.section}>
      <h3 className={styles.title}>Settings</h3>
      <div className={styles.card}>
        {items.map((item) => (
          <button key={item.id} className={styles.item}>
            <div className={styles.left}>
              <span className={`${styles.icon} ${styles[`icon_${item.icon}`]}`}>
                {icons[item.icon]}
              </span>
              <div>
                <p className={styles.itemTitle}>{item.title}</p>
                <p className={styles.itemSubtitle}>{item.subtitle}</p>
              </div>
            </div>
            <span className={styles.chevron}>›</span>
          </button>
        ))}
      </div>
    </div>
  );
};
